/** @jsxImportSource @emotion/react */
import { Grid as MuiGrid } from '@mui/material';
import { useMerchantData } from 'contexts';
import { FeatureFlag, MerchantClassSettingType } from 'enums';
import { useFeatureFlagEnabled } from 'hooks';
import SendGuideModule from 'modules/send-guide';
import { FC } from 'react';
import CompletedOrdersModule from '../completed-orders';
import CustomerOverviewModule from '../customer-overview';
import GrossSalesModule from '../gross-sales';
import OrdersToReviewModule from '../orders-to-review';
import QuickActionListModule from '../quick-action-list';
import RecentOrdersModule from '../recent-orders';
import * as styles from './DashboardOverview.styles';

const DashboardOverviewModule: FC = () => {
  const {
    checkMerchantDashboardSetting,
    getMerchantDashboardSettingValue,
    getMerchantUniqueId,
  } = useMerchantData();

  const planToPurchaseEnabled = useFeatureFlagEnabled(
    FeatureFlag.EnablePlanToPurchase
  );

  const authAndCapEnabled = checkMerchantDashboardSetting(
    MerchantClassSettingType.AuthoriseBeforeCapture
  );
  const categoryMst = getMerchantDashboardSettingValue(
    MerchantClassSettingType.ShowPlanToPurchase
  );
  const category = categoryMst && categoryMst?.toLowerCase();

  const showSendGuide =
    planToPurchaseEnabled &&
    (category === 'vet' || category === 'dental' || category === 'ndp');

  return (
    <>
      <QuickActionListModule />
      <MuiGrid
        container
        sx={{ flexGrow: 1 }}
        spacing={2}
        style={{ paddingTop: '16px' }}
      >
        <MuiGrid
          size={{ xs: 12 }}
          css={showSendGuide ? styles.moduleContainer(false) : null}
        >
          {showSendGuide && (
            <SendGuideModule
              category={category}
              merchantUniqueId={getMerchantUniqueId()}
            />
          )}
          <GrossSalesModule />
        </MuiGrid>
        <div css={styles.moduleContainer(authAndCapEnabled)}>
          {authAndCapEnabled && <OrdersToReviewModule />}
          <CompletedOrdersModule />
          <CustomerOverviewModule />
          <RecentOrdersModule />
        </div>
      </MuiGrid>
    </>
  );
};

export default DashboardOverviewModule;
